import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./../../../styleSheet/main/admin/hr/documents/directives/directives.css";
import deleteButtonIcon from "../../../media/delete-button.svg";
import httpClient, { API_URL } from "../../../services/httpClient";
import { downloadFile } from "../../../services/download";
import { getIconForSingleFile } from "../../../services/iconUtils";
import { useAuth } from "../../../AuthContext";
import BenefitDocumentsList from "./../../../components/BenefitDocumentsList";

const GroupInsurance = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const sectionTitle =
    windowWidth < 1500
      ? t("header.groupInsurance").split(" ")[0]
      : t("header.groupInsurance");

  const isAdmin = (userData) => {
    return (
      userData?.userRole === "admin" || userData?.userRole === "hr-manager"
    );
  };

  const apiEndpoint = useCallback(async () => {
    return await httpClient.get(
      "/hrdocuments/category?category=benefits&subcategory=groupinsurance",
      {
        withAuth: true,
      },
    );
  }, []);

  const apiEndpointWithDelete = useMemo(() => {
    const endpoint = apiEndpoint;
    endpoint.delete = async (id) => {
      return await httpClient.delete(`/hrdocuments/${id}`, {
        withAuth: true,
      });
    };
    endpoint.put = async (id) => {
      return await httpClient.put(`/hrdocuments/${id}`, {
        withAuth: true,
      });
    };
    return endpoint;
  }, [apiEndpoint]);

  return (
    <BenefitDocumentsList
      apiEndpoint={apiEndpointWithDelete}
      sectionTitle={sectionTitle}
      createPath="/administrator/pliki/benefity/ubezpieczenie-grupowe/nowe-ubezpieczenie-grupowe"
      editPathPrefix="/administrator/pliki/benefity/ubezpieczenie-grupowe/edytuj/"
      isAdmin={isAdmin}
      getIconForSingleFile={getIconForSingleFile}
      downloadFile={downloadFile}
      API_URL={API_URL}
      userData={userData}
      deleteButtonIcon={deleteButtonIcon}
    />
  );
};

export default GroupInsurance;
